module.exports = __webpack_public_path__ + "img/category-popular.a5747644.png";